import Modal from './accessibility';
import Dom from '../utility/dom';
import {debouncer} from '../utility/utils';
import {smoother, forceScrollSmootherUpdate} from "../utility/gsap";
import {playVideo, resetVideo} from './video';


const body = Dom.body;

function addModalActivation(handleOpenModal){
  // Move all modals to the end of the body
  if(!body.classList.contains('wp-admin')){
    const modals = document.querySelectorAll('.modal');
    modals.forEach(item => {
      const modal = item.parentNode.removeChild(item);
      body.appendChild(modal);
    });
  }
  

  // Modal Open
  Dom.modalTrigger.forEach(item => {
    item.addEventListener("click", (e) => {
      item.classList.add("active-modal-trigger");
      const target = document.getElementById(item.getAttribute("data-modal-target"));
      handleOpenModal(e, target);
    });
  });

  // In the event a modal link is added without the modal-target attr, try to check if it's got a modal id as an href attr.
  document.addEventListener('click', function(e){
    if (e.target.matches('a') || !!e.target.closest('a')) {
      // set class to link for when we close the modal 
      //to reset focus
      const link = e.target.matches('a') ? e.target : e.target.closest('a');
      const href = link.getAttribute('href');
      if (/^#/.test(href)) {
        const hash = href.substring(href.indexOf("#"));
        const hashTarget = document.getElementById(hash.substring(1));
        if (hash !== "#" && hashTarget && hashTarget.classList.contains('modal')) {
          link.classList.add('active-modal-trigger');
          handleOpenModal(e, hashTarget);
        }
      }
    }
  });

  // Modal Close
  document.addEventListener('click', function(e) {
    if (e.target.matches('.modal__close') || !!e.target.closest('.modal__close') || e.target.matches('.modal')) {
      modalClose(e);
    }
  });
  document.addEventListener('keypress', function(e) {
    if (e.target.matches('.modal__close') || !!e.target.closest('.modal__close') || e.target.matches('.modal')) {
      modalClose(e);
    }
  });
}

export const modalOpen = (e, modalEl = false) => {
  e.preventDefault();
  const el = e.target.matches('a') ? e.target : e.target.closest('a');
  if(e.type === 'click' || e.key === 'Enter' ){
    const target = modalEl ? modalEl : document.getElementById(el.getAttribute('data-modal-target'));
    if(!target){
      return;
    }

    target.classList.add('opening');

    setTimeout(function(){
      target.classList.add('active');
      target.setAttribute('aria-hidden', 'false');
      target.setAttribute('tabindex','1');

      const modalInner = target.querySelector('.modal__inner');
      modalInner.scrollTop = 0;

      Dom.body.classList.add('modal-active');
      if(smoother){
        smoother.paused(true);
      }
      else {
        Dom.body.classList.add('scroll-lock');
      }

      setTimeout(() => {
        target.classList.remove('opening');
      }, 1);
    }, 1);

    // Handles trapping focus in modal
    Modal.open(target);

    // add active class to body
    const body = document.querySelector('body');
    if(!body.classList.contains('wp-admin')){
      body.classList.add('modal-active');
    }

    // If there's a video in the modal, play it. 
    playVideo(target);
  }
}

function modalClose(e){
  if(e.key === 'Enter' || e.type === 'click'){
    e.preventDefault();
    let target = e.target.matches('.modal') ? e.target : e.target.closest('.modal');
    target.classList.add('closing');

    setTimeout(function(){
      target.setAttribute('aria-hidden', 'true');
      target.setAttribute('tabindex','-1');
      Dom.body.classList.remove('scroll-lock');
      Dom.body.classList.remove('modal-active');
      target.classList.remove('active');
      target.classList.remove('closing');
      if(smoother){
        smoother.paused(false);
      }

      // remove hiden class to header
      const header = document.querySelector('#masthead');
      if(header.classList.contains('hide-header')){
        header.classList.remove('hide-header');
      }
    }, 300);

    // Handles un-trapping focus in modal
    Modal.close(target);

    // remove active class to body
    const body = document.querySelector('body');
    if(body.classList.contains('modal-active')){
      body.classList.remove('modal-active');
    }

    // If there's a video in the modal, reset it.
    resetVideo(target);

    // reset focus on original link clicked
    const link = document.querySelector('.active-modal-trigger');
    if(!!link){
      link.classList.remove('active-modal-trigger');
  
      if(!link.closest('#masthead')){
        link.focus();
        link.blur();
      }
    }
  }
}

function set_admin_modal_css(){
  // ADMIN SECTION - HELP ADMIN EDITOR LAYOUT
  const body = document.getElementsByTagName("body")[0];
  if(body.classList.contains('block-editor-page')){
    let counterCheck = 0;

    // Because block editor markup isn't immediately loaded when the page is loaded, we may have to check multiple times.
    let checkForContentArea = setInterval(function(){
      counterCheck++;

      const contentArea = document.querySelector('.interface-interface-skeleton__content');

      // contenArea is found
      if(counterCheck > 20 || contentArea){
        // clear the interval
        clearInterval(checkForContentArea);

        // get css values needed from content area
        const contentWidth = contentArea.clientWidth;
        const contentLeft = contentArea.getBoundingClientRect().left;

        // set width on all modals
        const modals = document.querySelectorAll('.modal');
        modals.forEach(item => {
          item.style.width = contentWidth + 'px';
          item.style.left = contentLeft + 'px';
        });
      }
    }, 50);
  }
}


export function initializeModals(){
  addModalActivation(modalOpen)
}

export function initializeModalsEditor(){

  const handleOpenModal = (e, hash)=>{
    modalOpen(e, hash);
    set_admin_modal_css();
  }
  addModalActivation(handleOpenModal);

  set_admin_modal_css();

  // Resize modals on window resize
  window.addEventListener('resize', debouncer(function(){
    set_admin_modal_css();
  }, 15));

  // Resize modals when editor ui changes (fullscreen mode change or right sidebar show/hide)
  document.addEventListener('click', function(e){
    if(e.target.matches('button') || !!e.target.closest('button')){
      const button = e.target.matches('button') ? e.target : e.target.closest('button');
      if(!!button.closest('.edit-post-header__settings') || !!button.closest('.components-dropdown-menu__menu')){
        setTimeout(function(){
          set_admin_modal_css();
        }, 100);
      }
    }
  });

  // Add modal ID to the instructions in the block editor panel, showing how to link to the modal in another button if needed.
  if(body.classList.contains('block-editor-page')){
    document.addEventListener('click', function(e){
      const selected_block = document.querySelector('.wp-block.is-selected');
      if(!!selected_block){
        const modal = selected_block.querySelector('.modal');
        if(modal && !e.target.closest('.acf-block-panel')){
          const modal_id = modal.getAttribute('id');

          let checkForInstructions = setInterval(function(){
            const modalInstructionID = document.querySelector('.modal_block_id');

            // ID span found
            if(modalInstructionID){
              // clear the interval
              clearInterval(checkForInstructions);

              // Add the ID.
              modalInstructionID.innerHTML = modal_id;
            }
          }, 50);
        }
      }
    });
  }
}
